// extracted by mini-css-extract-plugin
export default {"list":"Naave3IMwLby3hR5kTxR7"};